import React from 'react';
import { FaMinus, FaPlus } from 'react-icons/fa';

const CartItem = ({ item, updateQuantity, removeFromCart }) => {
  return (
    <div className="flex gap-4 pb-4 border-b">
      <img 
        src={item.mainImage} 
        alt={item.name} 
        className="w-20 h-20 object-cover rounded-lg border" 
      />
      <div className="flex-1">
        <div className="flex justify-between">
          <p className="font-semibold text-gray-800">{item.name}</p>
        </div>
        <p className="text-sm text-gray-600">₹{item.price}</p>
        <div className="flex items-center mt-2 space-x-3">
          <button 
            onClick={() => updateQuantity(item.id, -1)}
            disabled={item.quantity <= 1}
            className={`p-1 rounded-full ${item.quantity <= 1 ? 'bg-gray-100 text-gray-400' : 'bg-purple-100 text-purple-700 hover:bg-purple-200'}`}
          >
            <FaMinus size={12} />
          </button>
          <span className="font-medium w-6 text-center">{item.quantity}</span>
          <button 
            onClick={() => updateQuantity(item.id, 1)}
            className="p-1 rounded-full bg-purple-100 text-purple-700 hover:bg-purple-200"
          >
            <FaPlus size={12} />
          </button>
          <button
            onClick={() => removeFromCart(item.id)}
            className="ml-2 text-xs text-gray-500 underline hover:text-red-500"
          >
            Remove
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartItem;